'use strict';

module.exports = require('./lib/ReactDOMServer');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dom/server.js
 ** module id = 133
 ** module chunks = 0
 **/